import { render, staticRenderFns } from "./NomeUnidadeOperacional.vue?vue&type=template&id=2585b615&"
import script from "./NomeUnidadeOperacional.vue?vue&type=script&lang=js&"
export * from "./NomeUnidadeOperacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports